import { useQueryClient } from '@tanstack/react-query';
import { useAxiosMutation } from './use-axios.hook';
import { DetermineSyncPlanApiRequest } from '../../../../types/requests/sync/determine-sync-plan.request';
import { applySyncPlan, determineSyncPlan, exportSyncDraft, exportSyncPlan } from '../../api/sync.api';
import { SyncPlanApiModel } from '../../../../types/models/sync/sync-plan.model';
import { ExportSyncDraftApiRequest } from '../../../../types/requests/sync/export-sync-draft.request';
import { ExportSyncPlanApiRequest } from '../../../../types/requests/sync/export-sync-plan.request';

const baseQueryKey = 'sync';

export const useDetermineSyncPlan = () => {
  const queryClient = useQueryClient();
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: DetermineSyncPlanApiRequest) => (await determineSyncPlan(params)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [baseQueryKey] }),
  });
  return [request, { ...result, syncPlan: data }] as const;
};

export const useApplySyncPlan = () => {
  const queryClient = useQueryClient();
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: SyncPlanApiModel) => (await applySyncPlan(params)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [baseQueryKey] }),
  });
  return [request, { ...result, appliedSyncPlan: data }] as const;
};

export const useExportSyncDraft = () => {
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: ExportSyncDraftApiRequest) => (await exportSyncDraft(params)).data,
  });
  return [request, result] as const;
};

export const useExportSyncPlan = () => {
  const [request, { data, ...result }] = useAxiosMutation({
    mutationFn: async (params: ExportSyncPlanApiRequest) => (await exportSyncPlan(params)).data,
  });
  return [request, result] as const;
};
